import React, { createContext, useContext } from "react";

const CarecentreFormContext = createContext(false);

/** Enable Carecentre form fields + layout inside this subtree (e.g. care plan form). */
export const CarecentreFormProvider = ({ children }) => (
  <CarecentreFormContext.Provider value={true}>
    {children}
  </CarecentreFormContext.Provider>
);

export const useCarecentreForm = () => useContext(CarecentreFormContext);

export default CarecentreFormContext;
